/**
 * HERE WILL BE ADDED ANY UTILITY FUNCTION NEED
 */

import { examsWithParamsLikedToLeucocytes } from '../config/constant';
import { getAgeInMonths, getAgeInYears } from './dates';
import { getApproximateHeight } from './getHeightFromAgeAndSex';

/**
 * Add spaces after each three digits of the number nbr
 * @param {*} nbr
 */
export const numberWithSpaces = (nbr) => {
    if (nbr === null || nbr === undefined) nbr = '';
    let parts = nbr.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join('.');
};

export const formatThousandInput = (value) => {
    if (value === null || value === undefined) return '';
    const digits = value.toString().replace(/\D/g, '');
    if (!digits) return '';
    return numberWithSpaces(digits);
};

export const parseThousandInput = (value) => {
    if (value === null || value === undefined) return 0;
    const normalized = value.toString().replace(/\s/g, '').replace(/,/g, '.');
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * @description determine if an array contains one or more items from another array.
 * @param {array} haystack the array to search.
 * @param {array} arr the array providing items to check for in the haystack.
 * @return {boolean} true|false if haystack contains at least one item from arr.
 */
export const containsElements = (haystack, arr) => {
    return arr.some((v) => haystack?.includes(v));
};

/**
 *
 * @param {*} string
 * @returns a string where only the first letter has been capitalized, the rest of the string is to lowercase
 */

export const capitalizeFirstLetter = (string) => {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 *
 * @param {*} string
 * @returns Returns a string where all the accents have been removed Ex: élève  => eleve
 */
export const removeAccents = (string) => {
    return string.normalize('NFD').replace(/\p{Diacritic}/gu, '');
};

/**
 * Format numbers with at max 3 digits after com
 * @param {*} number
 * @returns
 */
export const formatNumber = (number) => {
    // If the number is an integer after conversion, return it as an integer
    return number.toFixed(3).replace(/([^.])0+$/, '$1');
};

// const r = new IntersectionObserver

export const calculateGeneratedParams = (filledParameters, currentPatient, currentExam) => {
    let biliTotale,
        biliDirecte,
        calcium,
        albumine,
        transferrine,
        ferSerique,
        creatinine,
        cholesterolTotal,
        cholesterolHDL,
        triglyceride,
        ASAT,
        ALAT,
        PSAl,
        PSAt,
        dosage,
        diurese,
        U,
        V,
        P;
    //SPECIFIC TO NFS
    let leucocytes = 0,
        polyNeutrophiles = 0,
        polyEosinophiles = 0,
        polyBasophiles = 0,
        lymphocytes = 0,
        monocytes = 0,
        blastes = 0,
        promyelocytes = 0,
        myeloEosinophiles = 0,
        myeloNeutrophiles = 0,
        metaEosinophiles = 0,
        metaNeutrophiles = 0,
        atypicCells = 0;

    filledParameters.map((filledParam, index) => {
        /*-------- BILIRUBINE INDIRECTE --------------- */
        if (currentExam.abbreviation.toLowerCase() === 'BILI T/L'.toLowerCase()) {
            if (filledParam.parameterName.toLowerCase().includes('totale')) biliTotale = filledParam.resultValue;
            if (filledParam.parameterName.toLowerCase().includes(' Directe')) biliDirecte = filledParam.resultValue;
            if (filledParam.associatedFunction === 'bilirubineIndirecte') filledParameters[index].resultValue = biliTotale - biliDirecte;
        }

        /*-------- CALCIUM CORRIGÉ --------------- */
        if (currentExam.abbreviation.toLowerCase() === 'CA corr'.toLowerCase()) {
            if (filledParam.parameterName.toLowerCase().includes('calcium') && !filledParam.parameterName.toLowerCase().includes('corrig'))
                calcium = filledParam.resultValue * (filledParam.conversionFactor || 1);
            if (filledParam.parameterName.toLowerCase().includes('albumine')) albumine = filledParam.resultValue;
            if (filledParam.associatedFunction === 'correctedCalcium')
                filledParameters[index].resultValue = formatNumber(calcium + (40 - albumine) / 40);
        }

        /*-------- Capacité totale de Fixation --------------- */
        if (currentExam.abbreviation.toLowerCase() === 'TST/COEF SAT'.toLowerCase()) {
            if (filledParam.parameterName.toLowerCase() === 'transferrine') transferrine = filledParam.resultValue;
            if (filledParam.associatedFunction === 'ctf') filledParameters[index].resultValue = formatNumber(transferrine * 25);
        }

        /*-------- Coefficient de saturation en fer --------------- */
        if (currentExam.abbreviation.toLowerCase() === 'TST/COEF SAT'.toLowerCase()) {
            if (
                filledParam.parameterName.toLowerCase().includes('fer') &&
                removeAccents(filledParam.parameterName.toLowerCase()).includes('serique')
            )
                ferSerique = filledParam.resultValue * (filledParam.conversionFactor || 1);
            if (filledParam.associatedFunction === 'css')
                filledParameters[index].resultValue = formatNumber((ferSerique / (transferrine * 25)) * 100);
        }

        /*-------- Clairance de la créatinine (MDRD) --------------- */
        if (currentExam.abbreviation.toLowerCase() === 'CREAT-S'.toLowerCase()) {
            if (
                filledParam.parameterName.toLowerCase().includes('créatinine') &&
                !filledParam.parameterName.toLowerCase().includes('clairance')
            )
                creatinine = filledParam.resultValue * (filledParam.conversionFactor || 1);
            const ageInYears = getAgeInYears(currentPatient?.dateOfBirth);
            if (filledParam.associatedFunction === 'clairanceMDRD') {
                let result = 0;
                if (ageInYears < 21) {
                    const ageInMonths = getAgeInMonths(currentPatient?.dateOfBirth);
                    result = (36.5 * getApproximateHeight(ageInMonths, currentPatient?.sex)) / creatinine; //We use the value in micromol/L
                } else {
                    result = 186.6 * (creatinine / 88.4) ** -1.154 * getAgeInYears(currentPatient?.dateOfBirth) ** -0.203 * 1.212;
                    if (currentPatient?.sex === 'F') result = result * 0.742;
                }
                filledParameters[index].resultValue = formatNumber(result);
            }
        }

        if (currentExam.abbreviation.toLowerCase() === 'BILAN LIP'.toLowerCase()) {
            //Should have the abbreviation normally
            /*-------- LDL Cholesterol --------------- */
            if (
                removeAccents(filledParam.parameterName.toLowerCase()).includes('cholesterol') &&
                filledParam.parameterName.toLowerCase().includes('total')
            )
                cholesterolTotal = filledParam.resultValue;
            if (
                removeAccents(filledParam.parameterName.toLowerCase()).includes('cholesterol') &&
                filledParam.parameterName.toLowerCase().includes('hdl')
            )
                cholesterolHDL = filledParam.resultValue;
            if (removeAccents(filledParam.parameterName.toLowerCase()).includes('triglycerides')) triglyceride = filledParam.resultValue;
            if (filledParam.associatedFunction === 'LDLCholesterol')
                filledParameters[index].resultValue = (cholesterolTotal - cholesterolHDL - triglyceride / 5)
                    .toFixed(3)
                    .replace(/([^.])0+$/, '$1');

            /*-------- Indice d'athérogénicité --------------- */
            if (filledParam.associatedFunction === 'indiceAtherogenicite')
                filledParameters[index].resultValue = formatNumber(cholesterolTotal / cholesterolHDL);
        }

        /*-------- Rapport ALAT/ASAT --------------- */
        if (currentExam.abbreviation.toLowerCase() === 'ASAT/ALAT'.toLowerCase()) {
            if (filledParam.parameterName.toLowerCase().includes('asat')) ASAT = filledParam.resultValue;
            if (filledParam.parameterName.toLowerCase().includes('alat')) ALAT = filledParam.resultValue;
            if (filledParam.associatedFunction === 'ratioAlatAsat') filledParameters[index].resultValue = formatNumber(ALAT / ASAT);
        }

        /*-------- Rapport PSAl/PSAt --------------- */
        if (currentExam.abbreviation.toLowerCase() === 'PSA t+l'.toLowerCase()) {
            if (filledParam.parameterName.toLowerCase() === 'PSA T'.toLowerCase()) PSAt = parseFloat(filledParam.resultValue);
            if (filledParam.parameterName.toLowerCase() === 'PSA L'.toLowerCase()) PSAl = parseFloat(filledParam.resultValue);
            if (filledParam.associatedFunction === 'ratioPSAlPSAt') filledParameters[index].resultValue = formatNumber((PSAl * 100) / PSAt);
        }

        /*-------- Résultat sur 24H --------------- */
        if (
            filledParam.parameterName.toLowerCase().includes('dosage') ||
            removeAccents(filledParam.parameterName.toLowerCase()).includes('echantillon')
        )
            dosage = filledParam.resultValue;
        if (removeAccents(filledParam.parameterName.toLowerCase()).includes('diurese')) diurese = filledParam.resultValue;
        if (filledParam.associatedFunction === 'resultat24H') filledParameters[index].resultValue = formatNumber(dosage * diurese);

        /*-------- Clairance Créatinine --------------- */
        if (currentExam.examName.toLowerCase() === 'CLAIRANCE DE LA CREATININE'.toLowerCase()) {
            if (filledParam.parameterName.toLowerCase().includes('créatinine urinaire'))
                U = filledParam.resultValue * (filledParam.conversionFactor || 1);
            if (filledParam.parameterName.toLowerCase().includes('débit urinaire')) V = filledParam.resultValue;
            if (filledParam.parameterName.toLowerCase().includes('créatinine plasmatique'))
                P = filledParam.resultValue * (filledParam.conversionFactor || 1);
            if (filledParam.associatedFunction === 'clairanceCreatinine')
                filledParameters[index].resultValue = formatNumber((U * 1000 * V) / (P * 1440));
        }

        /*-------- Hemogramme Complet NFS --------------- */
        if (currentExam.abbreviation.toLowerCase() === 'NFS'.toLowerCase()) {
            if (filledParam.parameterName.toLowerCase() === 'leucocytes') leucocytes = parseFloat(filledParam.resultValue);
            if (
                filledParam.parameterName.toLowerCase() === 'Polynucléaires Neutrophiles'.toLowerCase() &&
                !filledParam.isLinkedToLeucocytes
            )
                polyNeutrophiles = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Polynucléaires Neutrophiles'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((polyNeutrophiles * leucocytes) / 100);

            if (
                filledParam.parameterName.toLowerCase() === 'Polynucléaires Eosinophiles'.toLowerCase() &&
                !filledParam.isLinkedToLeucocytes
            )
                polyEosinophiles = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Polynucléaires Eosinophiles'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((polyEosinophiles * leucocytes) / 100);

            if (filledParam.parameterName.toLowerCase() === 'Polynucléaires Basophiles'.toLowerCase() && !filledParam.isLinkedToLeucocytes)
                polyBasophiles = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Polynucléaires Basophiles'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((polyBasophiles * leucocytes) / 100);

            if (filledParam.parameterName.toLowerCase() === 'Lymphocytes'.toLowerCase() && !filledParam.isLinkedToLeucocytes)
                lymphocytes = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Lymphocytes'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((lymphocytes * leucocytes) / 100);

            if (filledParam.parameterName.toLowerCase() === 'Monocytes'.toLowerCase() && !filledParam.isLinkedToLeucocytes)
                monocytes = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Monocytes'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((monocytes * leucocytes) / 100);

            if (filledParam.parameterName.toLowerCase() === 'Blastes'.toLowerCase() && !filledParam.isLinkedToLeucocytes)
                blastes = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Blastes'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((blastes * leucocytes) / 100);

            if (filledParam.parameterName.toLowerCase() === 'Promyélocytes'.toLowerCase() && !filledParam.isLinkedToLeucocytes)
                promyelocytes = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Promyélocytes'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((promyelocytes * leucocytes) / 100);

            if (filledParam.parameterName.toLowerCase() === 'Myélocytes Eosinophiles'.toLowerCase() && !filledParam.isLinkedToLeucocytes)
                myeloEosinophiles = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Myélocytes Eosinophiles'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((myeloEosinophiles * leucocytes) / 100);

            if (filledParam.parameterName.toLowerCase() === 'Myélocytes Neutrophiles'.toLowerCase() && !filledParam.isLinkedToLeucocytes)
                myeloNeutrophiles = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Myélocytes Neutrophiles'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((myeloNeutrophiles * leucocytes) / 100);

            if (
                filledParam.parameterName.toLowerCase() === 'Métamyélocytes Eosinophiles'.toLowerCase() &&
                !filledParam.isLinkedToLeucocytes
            )
                metaEosinophiles = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Métamyélocytes Eosinophiles'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((metaEosinophiles * leucocytes) / 100);

            if (
                filledParam.parameterName.toLowerCase() === 'Métamyélocytes Neutrophiles'.toLowerCase() &&
                !filledParam.isLinkedToLeucocytes
            )
                metaNeutrophiles = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Métamyélocytes Neutrophiles'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((metaNeutrophiles * leucocytes) / 100);

            if (filledParam.parameterName.toLowerCase() === 'Formule leucocytaire'.toLowerCase()) {
                const sum =
                    polyNeutrophiles +
                    polyEosinophiles +
                    polyBasophiles +
                    lymphocytes +
                    monocytes +
                    blastes +
                    promyelocytes +
                    myeloEosinophiles +
                    myeloNeutrophiles +
                    metaEosinophiles +
                    metaNeutrophiles;

                filledParameters[index].resultValue = sum;

                if (sum !== 100) {
                    filledParameters[index].incorretValue = true;
                } else {
                    filledParameters[index].incorretValue = false;
                }
            }
        }

        //BACTERIOLOGICAL EXAMS INCLUDING CALCULATIONS ON LEUCOCYTES
        if (examsWithParamsLikedToLeucocytes.includes(currentExam.abbreviation)) {
            if (filledParam.parameterName.toLowerCase() === 'leucocytes') leucocytes = parseFloat(filledParam.resultValue);

            if (
                filledParam.parameterName.toLowerCase() === 'Polynucléaires Neutrophiles'.toLowerCase() &&
                !filledParam.isLinkedToLeucocytes
            )
                polyNeutrophiles = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Polynucléaires Neutrophiles'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((polyNeutrophiles * leucocytes) / 100);

            if (filledParam.parameterName.toLowerCase() === 'Lymphocytes'.toLowerCase() && !filledParam.isLinkedToLeucocytes)
                lymphocytes = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Lymphocytes'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((lymphocytes * leucocytes) / 100);

            if (filledParam.parameterName.toLowerCase() === 'Cellules atypiques'.toLowerCase() && !filledParam.isLinkedToLeucocytes)
                atypicCells = parseFloat(filledParam.resultValue) || 0;
            if (filledParam.parameterName.toLowerCase() === 'Cellules atypiques'.toLowerCase() && filledParam.isLinkedToLeucocytes)
                filledParameters[index].resultValue = formatNumber((atypicCells * leucocytes) / 100);
        }

        // return filledParameters;
    });

    return filledParameters;
};

export const getGreeting = () => {
    const now = new Date();
    console.log(now.getHours());
    let greeting = '';
    if (now.getHours() < 12) {
        greeting = 'Bonjour ';
    } else if (now.getHours() < 18) {
        greeting = 'Bon après-midi ';
    } else {
        greeting = 'Bonsoir ';
    }
    return greeting;
};

/**
 * Checks if a patient has passed the 28th week of pregnancy.
 * @param {Object} packSubscription - The pack subscription object.
 * @returns {{passed: boolean, week28Date: Date|null}} - Object with boolean and the 28th week date (or null if not found).
 */
export const hasPassed28Weeks = (packSubscription) => {
    if (!packSubscription?.responses) return { passed: false, week28Date: null };

    // Find the key containing both "Date" and "Conception" (case-insensitive)
    const conceptionKey = Object.keys(packSubscription.responses).find(
        (key) => key.toLowerCase().includes('date') && key.toLowerCase().includes('règles')
    );

    if (!conceptionKey) return { passed: false, week28Date: null };

    const conceptionDateStr = packSubscription.responses[conceptionKey];
    if (!conceptionDateStr) return { passed: false, week28Date: null };

    const conceptionDate = new Date(conceptionDateStr);
    if (isNaN(conceptionDate.getTime())) return { passed: false, week28Date: null };

    // Calculate the date at 28 weeks
    const week28Date = new Date(conceptionDate.getTime() + 28 * 7 * 24 * 60 * 60 * 1000);

    const now = new Date();
    const passed = now > week28Date;

    return { passed, week28Date };
};

/**
 * Merge pack subscriptions and pack bills so each subscription has its corresponding bill as 'packBill'.
 * @param {Array} packSubscriptions - Array of pack subscription objects.
 * @param {Array} packBills - Array of pack bill objects.
 * @returns {Array} - Array of pack subscriptions with embedded 'packBill' if found.
 */
export const mergePackSubscriptionsWithBills = (packSubscriptions, packBills) => {
    // Create a map for quick lookup: subscription uuid -> bill
    const billMap = {};
    packBills.forEach((bill) => {
        // Some bills have correspondingPackSubscription as object, some as uuid
        const subUuid =
            typeof bill.correspondingPackSubscription === 'string'
                ? bill.correspondingPackSubscription
                : bill.correspondingPackSubscription?.uuid;
        if (subUuid) {
            billMap[subUuid] = bill;
        }
    });

    // Merge: add 'packBill' property if found
    return packSubscriptions.map((sub) => ({
        ...sub,
        packBill: billMap[sub.uuid] || null
    }));
};

/**
 * Merge ordinary prescriptions and pack bills so each prescription has its corresponding bill as 'packBill'.
 * @param {Array}prescriptions - Array of pack prescription objects.
 * @param {Array} bills - Array of pack bill objects.
 * @returns {Array} - Array of pack prescriptions with embedded 'packBill' if found.
 */
export const mergeOrdinaryPrescriptionsWithBills = (prescriptions, bills) => {
    // Create a map for quick lookup: subscription uuid -> bill
    const billMap = {};
    bills.forEach((bill) => {
        // Some bills have correspondingPrescription as object, some as uuid
        const subUuid =
            typeof bill.correspondingPrescription === 'string'
                ? bill.correspondingPrescription
                : bill.correspondingPrescription?.uuid;
        if (subUuid) {
            billMap[subUuid] = bill;
        }
    });

    // Merge: add 'packBill' property if found
    return prescriptions.map((sub) => ({
        ...sub,
        bill: billMap[sub.uuid] || null
    }));
};
